<div class="warp">
    <p class="text" translate>
        questionBoard.edit.expense.selectExpenseTypes
    </p>
    <div cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <div class="selected" (click)="isSelectExpenseOpen = true">
            <p *ngIf="!selectedOptionExpenseName" translate>
                questionBoard.edit.lists-placeholder
            </p>
            <p *ngIf="selectedOptionExpenseName">{{ selectedOptionExpenseName }}</p>
            <img src="/assets/images/arrow-down.svg" />
        </div>
    </div>
</div>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="backdrop-selection" (backdropClick)="isSelectExpenseOpen = false"
    [cdkConnectedOverlayOpen]="isSelectExpenseOpen" [cdkConnectedOverlayPositions]="positonArea">
    <div class="menuSteps">
        <div *ngFor="let op of allOptionLists$ | async" class="op">
            <p translate (click)="updateSelection(op)">
                {{ op.name }}
            </p>
        </div>
    </div>
</ng-template>

<div class="warp-active-toggle">
    <p translate>questionBoard.edit.expense.allowDecimal</p>
    <que-toggle [toggleState]="questionForm.controls.isDecimal.value == true"
        (toggleEvent)="markDecimal($event)"></que-toggle>
</div>

<div class="warp-active-toggle">
    <p translate>questionBoard.edit.uploadFile.allowMultipleFiles</p>
    <que-toggle [toggleState]="questionForm.controls.allowMultipleFiles.value == true"
        (toggleEvent)="markMultipleFiles($event)"></que-toggle>
</div>